import { useForm } from "react-hook-form";
import { Download } from "lucide-react";
import GrayButton from "../../../components/UI/buttonUI/GrayButton";
import DownloadTemplate from "../../../components/common/DownloadTemplate";
import { DOWNLOAD_BULK_USER_TEMPLATE, UPDATE_BULK_USER } from "../apiEndpoints";
import UploadFileInput from "../../../components/UI/PageInput/UploadFileInput";
import PrimaryButton from "../../../components/UI/buttonUI/PrimaryButton";
import UpdateBulkUserSuccess from "../dialogs/UpdateBulkUserSuccess";
import MainPageLayout from "../../../layout/MainPageLayout";
import CenteredHeading from "../../../components/UI/headingsUI/CenteredHeading";
import useUploadSheet from "../../../CustomHooks/useAxios/useUploadSheet";
import ErrorDisplay from "../../../components/UI/ErrorDisplay";
import UpdateBulkUserSheetErrors from "../dialogs/UpdateBulkUserSheetErrors";

const UpdateBulkUserPage = () => {
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues: {
      sheet: undefined,
    },
  });
  const {
    executePost,
    loading,
    isSucceed,
    formError,
    formErrMsg,
    responseData,
    setFormError,
    errorResponse,
  } = useUploadSheet();
  const sheet = watch("sheet");

  const onSubmit = async (data) => {
    // send data into form data
    const formData = new FormData();
    formData.append("sheet", data.sheet[0]);
    //API calling
    executePost(formData, UPDATE_BULK_USER, reset);
  };

  return (
    <MainPageLayout headerConfig={{ title: "Update Bulk Users" }}>
      <div className="form-container">
        <CenteredHeading title="Update Bulk Users" />
        {formError &&
          (Array.isArray(errorResponse) ? (
            <UpdateBulkUserSheetErrors
              errorList={errorResponse}
              closeAction={() => setFormError(false)}
            />
          ) : (
            <ErrorDisplay
              message={formErrMsg}
              closeAction={() => setFormError(false)}
            />
          ))}
        <div className="form-border max-w-5xl mx-auto w-95% form-border">
          <div className="flex justify-between">
            <p className="text-dg2">
              {sheet && sheet[0]?.name ? "Uploaded" : "Upload"} Users File
            </p>
            <DownloadTemplate
              apiEndPoint={DOWNLOAD_BULK_USER_TEMPLATE}
              downloadFileName="update_bulk_user"
            />
          </div>
          <form
            onSubmit={!loading ? (e) => handleSubmit(onSubmit)(e) : undefined}
          >
            <UploadFileInput
              name="sheet"
              placeholder=".xlsx"
              accept=".xlsx, file/xlsx"
              register={{
                ...register("sheet", {
                  required: "Please choose a file",
                }),
              }}
              setValue={setValue}
              multiple={true}
              error={errors.sheet}
              uploadedFile={sheet}
              removeUploadedFile={() => setValue("sheet", "")}
            />
            <div className="sheet-upload-btn-wrap">
              <PrimaryButton
                btnText={!loading ? "Update Users" : "Update..."}
                loading={loading}
                Icon={Download}
                size={20}
              />
              <GrayButton
                btnText="Clear"
                width="w-40"
                onClick={() => reset()}
              />
            </div>
          </form>
          {isSucceed && <UpdateBulkUserSuccess viewDetails={responseData} />}
        </div>
      </div>
    </MainPageLayout>
  );
};

export default UpdateBulkUserPage;
